<script lang="ts">
  import { LOBBY_COPY } from "@spacecrew/shared";
</script>

<div class="overlay" role="alert">
  <p>{LOBBY_COPY.reconnecting}</p>
</div>

<style>
  .overlay { position: fixed; inset: 0; display: grid; place-items: center; background: rgba(0,0,0,0.82); z-index: 10; }
  p { border: 1px solid var(--warn); color: var(--warn); padding: 1rem 1.5rem; animation: blink 1.2s steps(2) infinite; }
  @keyframes blink { 50% { opacity: 0.35; } }
</style>
